import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/global.css";

function Statistics() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/auth/session`, { withCredentials: true })
      .then((res) => {
        if (res.data.user) {
          setUser(res.data.user);
        } else {
          navigate("/?error=Sessione Utente Inesistente");
        }
      })
      .catch(() => navigate("/?error=Sessione Utente Inesistente"));
  }, [navigate]);

  return (
    <main className="statistics_container">
      <div className="window">
        <h2>Statistiche Corrieri</h2>
        <div className="chart" id="couriersChart"></div>
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Consegne</th>
              <th>Ore di lavoro</th>
              <th>Valutazione</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Mario Rossi</td>
              <td>120</td>
              <td>80</td>
              <td>4.5</td>
            </tr>
            <tr>
              <td>Anna Bianchi</td>
              <td>100</td>
              <td>70</td>
              <td>4.7</td>
            </tr>
            <tr>
              <td>Giovanni Verdi</td>
              <td>90</td>
              <td>65</td>
              <td>4.6</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="window">
        <h2>Statistiche Camion</h2>
        <div className="chart" id="trucksChart"></div>
        <table>
          <thead>
            <tr>
              <th>Targa</th>
              <th>Modello</th>
              <th>Km Percorsi</th>
              <th>Consumo Carburante (L)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>AB123CD</td>
              <td>Iveco Daily</td>
              <td>15000</td>
              <td>1200</td>
            </tr>
            <tr>
              <td>EF456GH</td>
              <td>Mercedes Sprinter</td>
              <td>18000</td>
              <td>1350</td>
            </tr>
            <tr>
              <td>IJ789KL</td>
              <td>Ford Transit</td>
              <td>20000</td>
              <td>1500</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default Statistics;